import { gql } from '@apollo/client';

export const FETCH_WORKAROUNDS_OVERVIEW = gql`
  query GetWorkaroundOverview($locationUUID: String) {
    getWorkaroundOverview(locationUUID: $locationUUID) {
      applications {
        businessFunctionCount
        completionPercentage
        name
        revenue
        tier {
          color
          name
        }
        uuid
        workaroundTimelineCompliance {
          slaCompliant
          rtoCompliant
          mtoCompliant
          rpoCompliant
        }
      }
      totalBusinessFunctionsWorkarounds
      totalQualitativeFactorsWorkarounds
      totalProcessAreasWorkarounds
    }
  }
`;
